<template>
  <section :class="$s.featuresContainer">
    <feature-page :page-data="$store.state.pageContent" />
  </section>
</template>

<script>
import { GET_PAGE_CONTENT } from '~/store/index';
import FeaturePage from './FeaturePage.vue';

export default {
  layout: 'landing-page',

  components: {
    FeaturePage,
  },

  async fetch(context) {
    const pageData = await context.store.dispatch(GET_PAGE_CONTENT, {
      isFeaturePage: true,
      context,
    });

    const noFeaturePageDataFound = !(pageData && pageData.sections && pageData.sections.length);
    if (noFeaturePageDataFound) {
      context.error({ statusCode: 404, message: 'No Content Found' });
    }
  },

  head() {
    return (
      this.$store.state.pageContent &&
      this.$store.state.pageContent.meta
    ) || {};
  },
};
</script>

<style module="$s" lang="scss">
.featuresContainer {
  max-width: $section-max-width;
  margin: 0 auto;
}
</style>

